export interface IRegistrationProfileEntityAttributes {
	// Code of registration profile
	code: string;
	// Name of registration profile
	name: string;
	// Collateral class of registration profile if any
	collateralClass?: string;
	hasGrantors: boolean;
	hasSerialisedVehicle: boolean;
	hasSerialisedWatercraft: boolean;
}

/**
 * Registration profile for an SPG.
 * Currently stored in Brownfield and is not mapped to a table.
 */
export default class RegistrationProfileEntity implements IRegistrationProfileEntityAttributes {
	public code: string;
	
	public name: string;
	
	public collateralClass?: string;
	
	public hasGrantors: boolean;
	
	public hasSerialisedVehicle: boolean;
	
	public hasSerialisedWatercraft: boolean;
	

	constructor(attributes?: Partial<IRegistrationProfileEntityAttributes>) {
		if (attributes) {
			if (attributes.code !== undefined) {
				this.code = attributes.code;
			}
			if (attributes.name !== undefined) {
				this.name = attributes.name;
			}
			if (attributes.collateralClass !== undefined) {
				this.collateralClass = attributes.collateralClass;
			}
			if (attributes.hasGrantors !== undefined) {
				this.hasGrantors = attributes.hasGrantors;
			}
			if (attributes.hasSerialisedVehicle !== undefined) {
				this.hasSerialisedVehicle = attributes.hasSerialisedVehicle;
			}
			if (attributes.hasSerialisedWatercraft !== undefined) {
				this.hasSerialisedWatercraft = attributes.hasSerialisedWatercraft;
			}
		}
	}
}
